
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.754","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#007d57","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M10.004 13.25h10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M2.902 12.29l-1.328-1.328m11.267-8.414l-1.524-1.524a.94.94 0 00-1.326 0l-.764.764 2.85 2.85.764-.764a.94.94 0 00-.001-1.326zm-4.446.087l-6.024 6.02L.75 13.097l4.457-1.609 5.982-5.982m-5.822 5.788l-2.8-2.8","data-name":"Edit","stroke-linejoin":"round"}})])])
          )
        }
      }
    